import React from 'react';
import ResourceProperty from '../../../../common/resource/ResourceProperty';
import { tzNormalizeDate } from '../../../../../utils/date';
import { DATE_FORMAT } from '../../../../../config/locale';
import PricingProfileDateRangeProptype from '../proptypes/PricingProfileDateRangeProptypes';

const PricingProfileDateRangeBasicInformationResource = ({
  pricingProfileDateRange,
}) => {
  const { id, year, startDate, endDate, reason, corporate } =
    pricingProfileDateRange || {};

  return (
    <>
      <ResourceProperty label="ID:">{id || '-'}</ResourceProperty>

      <ResourceProperty label="Año:">{year || '-'}</ResourceProperty>

      <ResourceProperty label="Fecha Inicio:">
        {tzNormalizeDate({ date: startDate, format: DATE_FORMAT }) || '-'}
      </ResourceProperty>

      <ResourceProperty label="Fecha Fin:">
        {tzNormalizeDate({ date: endDate, format: DATE_FORMAT }) || '-'}
      </ResourceProperty>

      <ResourceProperty label="Motivo:">{reason || '-'}</ResourceProperty>

      <ResourceProperty label="Tipo:">
        {corporate ? 'Corporativo' : 'General'}
      </ResourceProperty>
    </>
  );
};

PricingProfileDateRangeBasicInformationResource.propTypes = {
  pricingProfileDateRange: PricingProfileDateRangeProptype,
};

PricingProfileDateRangeBasicInformationResource.defaultProps = {
  pricingProfileDateRange: null,
};

export default PricingProfileDateRangeBasicInformationResource;
